import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import classNames from 'classnames';
import moment from 'moment';
import { ADGMResponsiveModal } from 'aurora-components';
import FetchUser from './FetchUser';
import styles from './styles';

const initialState = {
  userType: 'person',
  userInputId: '',
};

function AddBrokerModal(props) {
  const {
    classes,
    intl,
    locale,
    modalConfig,
    toggleModal,
    handleModalClose,
    modalTitle,
    userDetailsTitle,
    apiResponse,
    handleFetchUser,
    handleAddUser,
    FieldComponent,
    fetchError,
    buttonText,
  } = props;
  const [formState, setFormState] = useState(initialState);

  const isResponseCompany = apiResponse && !!(apiResponse?.tradeLicenseNo || apiResponse.tradeLicenseNumber);
  const isResponsePerson = apiResponse && !(apiResponse?.tradeLicenseNo || apiResponse.tradeLicenseNumber);

  useEffect(() => {
    setFormState({ ...formState, userType: isResponseCompany ? 'company' : 'person' });
  }, [isResponseCompany, isResponsePerson]);

  useEffect(() => {
    return () => {
      setFormState(initialState);
    };
  }, []);

  const handleStateChange = e => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value,
    });
  };

  const handleDateChange = (name, value) => {
    setFormState({
      ...formState,
      [name]: moment(value)
        .startOf('day')
        .format('YYYY-MM-DDTHH:mm:ss'),
    });
  };

  const handleSelect = (name, value) => {
    setFormState(state => ({
      ...state,
      [name]: value?.value || null,
    }));
  };

  const fetchUser = () => {
    let id = null;
    if (formState.userType === 'person') {
      id = formState.userInputId?.replace(/-/g, '');
    }
    if (formState.userType === 'company') {
      id = formState.userInputId;
    }
    handleFetchUser(id, formState.userType);
  };

  const isSubmitDisabled = useMemo(() => {
    if (modalConfig.isEditMode) return true;
    if (apiResponse) return false;
    return true;
  }, [apiResponse, formState]);
  const onModalClose = () => {
    setFormState(initialState);
    handleModalClose();
  };

  const onModalToggle = () => {
    if (modalConfig.isEditMode) {
      onModalClose();
    }
    toggleModal();
  };

  const addUser = () => {
    handleAddUser(formState, modalConfig.selectedUser);
    setFormState(initialState);
  };

  return (
    <ADGMResponsiveModal
      open={modalConfig.open}
      toggleModal={onModalToggle}
      onClose={onModalClose}
      title={modalTitle}
      disablePortal
      customClasses={{
        modal:
          (isResponseCompany && formState.userType === 'company' && classes.buyerModalPerson) ||
          (isResponsePerson && formState.userType === 'person' && classes.buyerModalPerson),
      }}
    >
      <div>
        <FetchUser
          formState={formState}
          handleStateChange={handleStateChange}
          title={userDetailsTitle}
          fetchUser={fetchUser}
          apiResponse={apiResponse}
          isEditMode={modalConfig.isEditMode}
          fetchError={fetchError}
        />
        {apiResponse && (
          <>
            {/* Input fields container */}
            <FieldComponent
              locale={locale}
              intl={intl}
              formState={formState}
              apiResponse={apiResponse}
              isResponseCompany={isResponseCompany}
              isResponsePerson={isResponsePerson}
              handleStateChange={handleStateChange}
              handleDateChange={handleDateChange}
              handleSelect={handleSelect}
            />
          </>
        )}
        <div className={classes.modalFooter}>
          <div className={classes.subPanel}>
            <Button
              className={classNames(classes.mediumButton, classes.addBuyerButton)}
              disabled={isSubmitDisabled}
              onClick={addUser}
            >
              {buttonText}
            </Button>
          </div>
        </div>
      </div>
    </ADGMResponsiveModal>
  );
}

AddBrokerModal.propTypes = {
  classes: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  modalConfig: PropTypes.object.isRequired,
  toggleModal: PropTypes.func.isRequired,
  modalTitle: PropTypes.node.isRequired,
  userDetailsTitle: PropTypes.node.isRequired,
  buttonText: PropTypes.node.isRequired,
  apiResponse: PropTypes.object.isRequired,
  handleFetchUser: PropTypes.func.isRequired,
  handleAddUser: PropTypes.func.isRequired,
  handleModalClose: PropTypes.func.isRequired,
  FieldComponent: PropTypes.node.isRequired,
  fetchError: PropTypes.object.isRequired,
};

AddBrokerModal.defaultProps = {};

export default withStyles(styles)(AddBrokerModal);
